<template v-if="list.length" lang="html">
  <table class="vcv-table">
    <thead>
      <tr>
        <th class="column-checkbox">
          <input type="checkbox" v-model="selectedAll" class="checkbox" :id="'allResponses'">
          <label :for="'allResponses'"></label>
        </th>

        <th class="column-candidate" @click="setSortingMethod('surname')">
          {{ $tr('common.list.candidate') }}
          <i v-if="sorting.name === 'surname'" class="fa" :class="sortingIcon"></i>
        </th>

        <th class="column-status" @click="setSortingMethod('status')">
          {{ $tr('common.list.status') }}
          <i v-if="sorting.name === 'status'" class="fa" :class="sortingIcon"></i>
        </th>

        <th class="column-rating" @click="setSortingMethod('rating')">
          {{ $tr('common.list.rating') }}
          <i v-if="sorting.name === 'rating'" class="fa" :class="sortingIcon"></i>
        </th>

        <th class="column-already-worked">
          {{ $tr('common.list.alreadyWorked') }}
        </th>

        <th class="column-cv">
          {{ $tr('common.list.cvLink') }}
        </th>

        <th class="column-date" @click="setSortingMethod('date')">
          {{ $tr('common.list.date') }}
          <i v-if="sorting.name === 'date'" class="fa" :class="sortingIcon"></i>
        </th>

        <th class="column-phone" @click="setSortingMethod('phone')">
          {{ $tr('common.list.phone') }}
          <i v-if="sorting.name === 'phone'" class="fa" :class="sortingIcon"></i>
        </th>

        <th class="column-email" @click="setSortingMethod('email')">
          {{ $tr('common.list.email') }}
          <i v-if="sorting.name === 'email'" class="fa" :class="sortingIcon"></i>
        </th>

        <!-- <th class="column-comments">
          {{ $tr('common.list.comments') }}
        </th>

        <th class="column-actions">
        </th> -->
      </tr>
    </thead>
    <tbody>
      <response-row
        v-for="(item, index) in list"
        :model="item"
        :key="index"
      />
    </tbody>
  </table>
</template>

<script>
  import ResponseRow from './Row.vue'

  export default {
    name: 'responses-list',

    components: {
      ResponseRow
    },

    props: {
      list: Array,
      isItSearch: {
        type: Boolean,
        default: false
      }
    },

    methods: {
      setSortingMethod (method) {
        const sorting = this.$store.getters['responses/sorting']
        this.$store.dispatch('responses/updateSorting', {
          name: method,
          order: (sorting.name !== method || sorting.order === 'desc') ? 'asc' : 'desc'
        })
      }
    },

    computed: {
      selectedAll: {
        get () {
          return this.list.every(response => this.$store.getters['responses/isSelected'](response))
          // return this.$store.getters['responses/isSelectedAll']
        },

        set (val) {
          this.list.forEach(response =>
            this.$store.commit('responses/select', { model: response, value: val }))
          // this.$store.commit('responses/selectAll', val)
        }
      },

      sorting () {
        return this.$store.getters['responses/sorting']
      },

      sortingIcon () {
        return {
          'fa-caret-down': this.sorting.order === 'desc',
          'fa-caret-up': this.sorting.order === 'asc'
        }
      }
    },

    beforeMount () {}
  }
</script>

<style lang="scss" scoped>
  @import "../../../../styles/colors.scss";

  .vcv-table {
    border-collapse: collapse;

    thead {
      th {
        background: rgba(170, 170, 170, 0.1);
        font-size: 0.9em;
        font-weight: 200;
        padding: 4px 5px;
        cursor: pointer;

        label {
          margin: 0;
        }
      }
    }

    .vcv-table-row {
      border-bottom: 1px solid #e5e5e5;
    }

    .column-checkbox {
      width: 60px;
    }

    .column-candidate {
      width: calc(30% - 60px);
    }

    .column-status {
      width: 15%;
    }

    .column-rating {
      width: 10%;
    }

    .column-cv {
      width: 5%;
    }

    .column-already-worked {
      width: 10%;
    }

    .column-date,
    .column-phone,
    .column-email {
      width: 10%;
    }

    .column-comments {
      width: 20%;
    }

    .column-actions {
      text-align: center;
    }
  }
</style>
